import { Component, inject, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-document-viewer',
  imports: [],
  templateUrl: './document-viewer.html',
  styleUrl: './document-viewer.scss',
})
export class DocumentViewer {
  //private dialogService = inject(DialogService);
  //private translate = inject(TranslateService);
  //private messageService = inject(MessageService);
  //private router = inject(Router);
  private route = inject(ActivatedRoute);
  //private socket = inject(Socket);
  public api = inject(ApiService);
  private sanitzer = inject(DomSanitizer);

  pdfData = signal<SafeResourceUrl | null>(null);
  error = signal<string | null>(null);

  constructor() {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.api.waitForAPI().then(() => {
        this.api
          .getPublicFinanceTransactionInvoice(params['docid'])
          .then((result) => {
            console.log(result);
            console.log(result.type);

            if (result.type == 'application/pdf') {
              this.pdfData.set(this.sanitzer.bypassSecurityTrustResourceUrl(
                URL.createObjectURL(result),
              ));
            } else {
              result
                .text()
                .then((result) => {
                  let json = JSON.parse(result);
                  this.error.set('There was an error loading this document');
                })
                .catch((reason) => {
                  console.error(reason);
                });
            }
          })
          .catch((reason) => {
            console.error(reason);
          });
      });
    });
  }
}
